const paths = {
  root: "/",
  profile: "/profile",
  settings: "/settings",
  notifications: "/notifications",
  auth: {
    root: "/auth",
    login: "/auth/login",
    code: "/auth/code",
    forgetPassword: "/auth/forget-password",
    resetPassword: "/auth/reset-password",
  },
  users: {
    root: "/users",
    list: "/users/list",
    create: "/users/create",
  },
  applications: {
    root: "/applications",
    list: "/applications/list",
    leave: "/applications/leave",
    loan: "/applications/loan",
    salaryAllowance: "/applications/salaryAllowance",
    mission: "/applications/mission",
    certificate: "/applications/certificate",
    details: "/applications/details",
    leaveEdit: "/applications/leave/edit",
    loanEdit: "/applications/loan/edit",
    salaryAllowanceEdit: "/applications/salaryAllowance/edit",
    missionEdit: "/applications/mission/edit",
    certificateEdit: "/applications/certificate/edit",
    detailsEdit: "/applications/details/edit",
    overtime: "/applications/overtime",
    overtimeEdit: "/applications/overtime/edit",
    employeeActionWarning: "/applications/employee-action/warning",
    employeeActionAppreciation: "/applications/employee-action/appreciation",
    employeeActionList: "/applications/employee-action/list",
  },
  calendar: {
    calendar: "/calendar",
  },
  leaveHeatmap: "/leave-heatmap",
  publicCalendar: "/public-calendar",
  pendingActions: {
    root: "/pending",
    list: "/pending/list",
    approve: "/pending/approve",
  },
  messages: {
    root: "/messages",
    list: "/messages/list",
    detail: "/messages/detail/:id",
  },
  dashboard: "/dashboard",
  meetingRoom: "/meeting-room",
  announcements: {
    root: "/announcements",
    list: "/announcements/list",
    create: "/announcements/create",
    detail: "/announcements/detail/:id",
  },
  surveys: {
    root: "/surveys",
    list: "/surveys/list",
    create: "/surveys/create",
    detail: "/surveys/detail/:id",
    submit: "/surveys/submit/:id",
    results: "/surveys/results/:id",
  },
  attendance: {
    root: "/attendance",
    today: "/attendance/today",
    checkIn: "/attendance/check-in",
    report: "/attendance/report",
    teamToday: "/attendance/team/today",
    teamReport: "/attendance/team/report",
  },
  training: {
    root: "/training",
    list: "/training/list",
    create: "/training/create",
    detail: "/training/detail/:id",
    myEnrollments: "/training/my-enrollments",
  },
};
const PathsTitle = {
  profile: "نمایه",
  settings: "تنظیمات",
  notifications: "پیام ها",
  auth: {
    root: "Auth",
    login: "Auth login",
    forgetPassword: "فراموشی رمز عبور",
    resetPassword: "فراموشی رمز عبور",
  },
  users: {
    root: "Users",
    list: "Users list",
    create: "Users create",
  },
  applications: {
    list: "درخواست ها",
    leave: "درخواست مرخصی",
    loan: "درخواست وام",
    salaryAllowance: "درخواست مساعده",
    mission: "درخواست مأموریت",
    certificate: "درخواست گواهی اشتغال",
    details: "جزییات درخواست",
    overtime: "درخواست اضافه کار",
    employeeActionWarning: "درخواست اخطار",
    employeeActionAppreciation: "درخواست تشویق",
    employeeActionList: "لیست درخواست های اخطار و تشویق",
  },
  calendar: {
    calendar: "تقویم",
  },
  leaveHeatmap: "نمودار heatmap مرخصی",
  publicCalendar: "تقویم عمومی",
  pendingActions: {
    root: "درخواست ها",
    list: "لیست درخواست ها",
    approve: "تایید یا رد درخواست",
  },
  messages: {
    list: "پیام‌ها",
    detail: "جزئیات پیام",
  },
  dashboard: "داشبورد",
  meetingRoom: "اتاق جلسه",
  announcements: {
    list: "اعلانات",
    create: "ایجاد اعلان",
    detail: "جزئیات اعلان",
  },
  surveys: {
    list: "نظرسنجی‌ها",
    create: "ایجاد نظرسنجی",
    detail: "جزئیات نظرسنجی",
    submit: "شرکت در نظرسنجی",
    results: "نتایج نظرسنجی",
  },
  attendance: {
    today: "حضور امروز",
    checkIn: "ثبت ورود",
    report: "گزارش حضور",
    teamToday: "حضور تیم امروز",
    teamReport: "گزارش حضور تیم",
  },
  training: {
    list: "دوره‌های آموزشی",
    create: "ایجاد دوره",
    detail: "جزئیات دوره",
    myEnrollments: "دوره‌های من",
  },
};

export { paths, PathsTitle };
